<template>
  <layout>
    <div slot="content">
      <i-card title="出票处理">
        <div slot="content">
          <!-- 筛选区域 -->
          <el-form :inline="true" size="small">
            <el-form-item label="订单号">
              <el-input v-model="filter.uuid" placeholder="订单号" clearable></el-input>
            </el-form-item>
            <el-form-item label="订单简码">
              <el-input v-model="filter.short_code" placeholder="订单简码" clearable></el-input>
            </el-form-item>
            <el-form-item label="联系人手机">
              <el-input v-model="filter.linker_mobile" placeholder="联系人手机" clearable></el-input>
            </el-form-item>
            <el-form-item label="联系人姓名">
              <el-input v-model="filter.linker_name" placeholder="联系人姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="出行日期">
              <el-date-picker
                v-model="filter.use_date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                style="width:340px"
                clearable>
              </el-date-picker>
            </el-form-item>
            <el-form-item label="商品名称">
              <el-select v-model="filter.product_id" placeholder="商品名称" style="width:175px" clearable>
                <el-option v-for="p in productList" :key="p.id" :label="p.title" :value="p.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单来源">
              <el-select v-model="filter.app_id" filterable placeholder="订单来源" style="width:200px" clearable>
                <el-option v-for="app in appOptions" :key="app.value" :label="app.label+'('+app.platform_name+')'" :value="app.value"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-form :inline="true" size="small" style="text-align:right">
            <el-form-item>
              <el-button type="primary" @click="loadList(1)">查找</el-button>
              <el-button type="primary" @click="exportData">导出</el-button>
              <el-button @click="resetFilter">重置</el-button>
            </el-form-item>
          </el-form>

          <!-- 列表区域 -->
          <div v-loading="loading" style="overflow-x:auto;padding-bottom:20px;">
            <div class="no-data" v-if="orderList.length === 0">暂无已沟通的订单</div>
            <div class="order-card" v-for="order in orderList" :key="order.uuid">
              <!-- 订单头部信息 -->
              <div class="order-header">
                <div class="order-meta-grid">
                  <div class="meta-item"><label>订单号：</label>{{ order.uuid }}</div>
                  <div class="meta-item"><label>商品：</label>{{ order.title }}（{{ order.goods_type }}）</div>
                  <div class="meta-item"><label>联系人：</label>{{ order.linker_name }}</div>
                  <div class="meta-item"><label>联系手机：</label>{{ order.linker_mobile }}</div>
                  <div class="meta-item"><label>出行日期：</label>{{ order.use_date }}</div>
                  <div class="meta-item"><label>购买数量：</label>{{ order.goods_count }} 张</div>
                  <div class="meta-item" v-if="order.meeting_info || order.meeting_point">
                    <label>集合地点：</label>
                    <el-tag size="mini" type="warning">{{ (order.meeting_info && order.meeting_info.name) || order.meeting_point }}</el-tag>
                    <el-popover
                      v-if="order.meeting_info && (order.meeting_info.address || (order.meeting_info.image_urls && order.meeting_info.image_urls.length) || order.meeting_info.longitude || order.meeting_info.latitude)"
                      placement="right"
                      trigger="hover"
                      width="320"
                    >
                      <div class="mp-detail">
                        <div class="mp-detail-row" v-if="order.meeting_info.address"><strong>地址：</strong>{{ order.meeting_info.address }}</div>
                        <div class="mp-detail-row" v-if="order.meeting_info.longitude || order.meeting_info.latitude">
                          <strong>坐标：</strong>{{ order.meeting_info.longitude }} , {{ order.meeting_info.latitude }}
                        </div>
                        <div class="mp-detail-images" v-if="order.meeting_info.image_urls && order.meeting_info.image_urls.length">
                          <el-image
                            v-for="(url, i) in order.meeting_info.image_urls"
                            :key="i"
                            :src="url"
                            :preview-src-list="order.meeting_info.image_urls"
                            fit="cover"
                            class="mp-detail-thumb"
                          />
                        </div>
                      </div>
                      <el-button slot="reference" size="mini" type="text" style="margin-left:6px;">详情</el-button>
                    </el-popover>
                    <el-button size="mini" type="text" style="margin-left:6px;" @click="openEditMeeting(order)">修改</el-button>
                  </div>
                  <div class="meta-item" v-else>
                    <label>集合地点：</label>
                    <span style="color:#999;margin-right:6px;">未设置</span>
                    <el-button size="mini" type="text" @click="openEditMeeting(order)">设置</el-button>
                  </div>
                  <div class="meta-item" v-if="order.meeting_time"><label>集合时间：</label><el-tag size="mini" type="warning">{{ order.meeting_time }}</el-tag></div>
                  <div class="meta-item" v-if="order.ship && order.ship.sailings_code"><label>航班号：</label>{{ order.ship.sailings_code }}</div>
                  <div class="meta-item"><label>订单来源：</label>{{ order.app_name }}（{{ order.app_platform_name }}）</div>
                </div>
                <div class="order-actions">
                  <el-tag size="small" type="warning">已沟通</el-tag>
                  <div class="progress-text">
                    已出票：{{ getTicketedCount(order.people) }}/{{ order.people.length }}
                  </div>
                </div>
              </div>

              <!-- 游客列表 -->
              <table class="people-table">
                <thead>
                  <tr>
                    <th width="12%">姓名</th>
                    <th width="20%">证件号码</th>
                    <th width="8%">证件类型</th>
                    <th width="8%">年龄</th>
                    <th width="10%">手机</th>
                    <th width="10%">出票状态</th>
                    <th width="32%">操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="people in order.people" :key="people.id" :class="{'ticketed-row': people.ticket_status === 1}">
                    <td>{{ people.name }}</td>
                    <td>{{ maskIdCard(people.cert_no, people.cert_type) }}</td>
                    <td>{{ people.cert_type }}</td>
                    <td>{{ people.age }}</td>
                    <td>{{ people.mobile }}</td>
                    <td>
                      <el-tag size="mini" :type="people.ticket_status === 1 ? 'success' : 'danger'">
                        {{ people.ticket_status_name }}
                      </el-tag>
                    </td>
                    <td>
                      <template v-if="people.ticket_status === 0">
                        <el-button size="mini" type="primary" @click="openTicketDialog(order, people)">标记已出票</el-button>
                      </template>
                      <template v-else>
                        <el-button size="mini" type="text" @click="viewImages(people.ticket_images)">查看凭证</el-button>
                        <el-button size="mini" type="text" @click="openTicketDialog(order, people)">重新上传</el-button>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- 分页 -->
          <div class="page-wrap">
            <el-pagination
              background
              :page-size="15"
              :current-page="pageInfo.current_page"
              layout="prev, pager, next"
              @current-change="changePage"
              :total="pageInfo.total">
            </el-pagination>
          </div>
        </div>
      </i-card>

      <!-- 标记出票对话框 -->
      <el-dialog title="标记已出票" :visible.sync="ticketDialog.show" width="520px" @close="closeTicketDialog">
        <div class="ticket-dialog-info">
          <p><strong>游客：</strong>{{ ticketDialog.peopleName }}</p>
          <p><strong>所属订单：</strong>{{ ticketDialog.orderUuid }}</p>
        </div>
        <div style="margin-top:12px;">
          <div style="font-size:13px;color:#666;margin-bottom:8px;">上传出票凭证（可多张，选填）</div>
          <i-upload v-model="ticketDialog.images" :max-files="5"></i-upload>
        </div>
        <div slot="footer">
          <el-button @click="ticketDialog.show = false">取消</el-button>
          <el-button type="primary" :loading="ticketDialog.loading" @click="doMarkTicketed">确认已出票</el-button>
        </div>
      </el-dialog>

      <!-- 查看凭证图片对话框 -->
      <el-dialog title="出票凭证" :visible.sync="imagesDialog.show" width="600px">
        <div v-if="imagesDialog.images.length === 0" style="text-align:center;color:#999;padding:20px;">暂无凭证图片</div>
        <div v-else style="overflow:hidden;">
          <div v-for="(img, idx) in imagesDialog.images" :key="idx" style="float:left;margin:6px;">
            <el-image :src="img.file_url" fit="cover" style="width:150px;height:150px;" :preview-src-list="imagesDialog.images.map(i=>i.file_url)"></el-image>
          </div>
        </div>
      </el-dialog>

      <!-- 修改集合点对话框 -->
      <el-dialog title="修改集合点" :visible.sync="editMeeting.show" width="640px">
        <div style="margin-bottom: 12px;color:#666;font-size:13px;">调整订单的集合地点 / 时间，不影响订单当前状态；客户端订单详情会同步更新。</div>
        <el-form label-width="80px" size="small">
          <el-form-item label="集合地点">
            <el-select
              v-model="editMeeting.form.meeting_point_id"
              placeholder="请选择集合地点（可选）"
              clearable
              style="width:100%"
              @change="onEditMeetingPointChange"
            >
              <el-option v-for="mp in meetingPointOptions" :key="mp.id" :label="mp.name" :value="mp.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="集合时间">
            <el-select
              v-model="editMeeting.form.meeting_time"
              placeholder="请选择集合时间（可选，整点/半点/50分）"
              style="width:100%"
              clearable
              filterable
            >
              <el-option v-for="t in meetingTimeOptions" :key="t" :label="t" :value="t"/>
            </el-select>
          </el-form-item>
          <el-form-item label="" v-if="selectedEditMeetingPoint">
            <div class="mp-preview">
              <div class="mp-preview-title">
                <i class="el-icon-location-outline"></i>
                {{ selectedEditMeetingPoint.name }}
              </div>
              <div class="mp-preview-address" v-if="selectedEditMeetingPoint.address">{{ selectedEditMeetingPoint.address }}</div>
              <div class="mp-preview-coord" v-if="selectedEditMeetingPoint.longitude || selectedEditMeetingPoint.latitude">
                坐标：{{ selectedEditMeetingPoint.longitude }} , {{ selectedEditMeetingPoint.latitude }}
              </div>
              <div class="mp-preview-images" v-if="selectedEditMeetingPoint.image_urls && selectedEditMeetingPoint.image_urls.length">
                <el-image
                  v-for="(url, i) in selectedEditMeetingPoint.image_urls"
                  :key="i"
                  :src="url"
                  :preview-src-list="selectedEditMeetingPoint.image_urls"
                  fit="cover"
                  class="mp-preview-image"
                />
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="editMeeting.show = false">取消</el-button>
          <el-button type="primary" :loading="editMeeting.loading" @click="submitEditMeeting">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
import iUpload from '@/components/i-upload'

export default {
  name: 'ticket-processing',
  components: { iUpload },
  data() {
    return {
      orderList: [],
      loading: false,
      pageInfo: { current_page: 1, total: 0 },
      filter: {
        uuid: '',
        short_code: '',
        linker_mobile: '',
        linker_name: '',
        use_date: '',
        product_id: '',
        app_id: '',
      },
      productList: [],
      appOptions: [],
      ticketDialog: {
        show: false,
        loading: false,
        peopleId: null,
        peopleName: '',
        orderUuid: '',
        images: [],
      },
      imagesDialog: {
        show: false,
        images: [],
      },
      meetingPointOptions: [],
      editMeeting: {
        show: false,
        loading: false,
        form: {
          uuid: '',
          meeting_point_id: '',
          meeting_point: '',
          meeting_time: '',
        },
      },
    }
  },
  computed: {
    meetingTimeOptions() {
      const list = []
      for (let h = 0; h < 24; h++) {
        const hh = String(h).padStart(2, '0');
        ['00', '30', '50'].forEach(mm => list.push(`${hh}:${mm}`))
      }
      return list
    },
    selectedEditMeetingPoint() {
      const id = this.editMeeting.form.meeting_point_id
      if (!id) return null
      return this.meetingPointOptions.find(mp => mp.id === id) || null
    },
  },
  methods: {
    loadList(page = '') {
      this.loading = true
      if (page) this.pageInfo.current_page = page
      this.$http.request('ticketingList', {
        filter: this.filter,
        page: this.pageInfo.current_page,
      }).then(res => {
        this.orderList = res.data
        this.pageInfo = res.meta
        this.loading = false
        window.scrollTo(0, 0)
      }).catch(() => { this.loading = false })
    },
    changePage(page) {
      this.pageInfo.current_page = page
      this.loadList()
    },
    resetFilter() {
      for (let k in this.filter) {
        this.filter[k] = ''
      }
      this.loadList(1)
    },
    exportData() {
      const url = this.$http.request('exportTicketingList', { filter: this.filter, hash: Math.random() * 1000 }, true)
      window.open(url)
    },
    getProductList() {
      this.$http.request('productList', { type: 0 }).then(res => {
        this.productList = res.data
      })
    },
    getAppOptions() {
      this.$http.request('appListOptions').then(res => {
        this.appOptions = res.data
      })
    },
    getTicketedCount(people) {
      return people.filter(p => p.ticket_status === 1).length
    },
    openTicketDialog(order, people) {
      this.ticketDialog.peopleId = people.id
      this.ticketDialog.peopleName = people.name
      this.ticketDialog.orderUuid = order.uuid
      this.ticketDialog.images = people.ticket_images ? [...people.ticket_images] : []
      this.ticketDialog.show = true
    },
    closeTicketDialog() {
      this.ticketDialog.images = []
    },
    doMarkTicketed() {
      this.ticketDialog.loading = true
      this.$http.request('markPeopleTicketed', {
        people_id: this.ticketDialog.peopleId,
        images: this.ticketDialog.images,
      }).then(res => {
        this.ticketDialog.loading = false
        if (res.status === 'success') {
          this.ticketDialog.show = false
          this.$message({ message: '出票状态已更新', type: 'success' })
          this.loadList()
        }
      }).catch(() => { this.ticketDialog.loading = false })
    },
    viewImages(images) {
      this.imagesDialog.images = images || []
      this.imagesDialog.show = true
    },
    maskIdCard(idNumber, certType) {
      if (certType !== '身份证' || !idNumber || idNumber.length < 15) return idNumber
      return idNumber.slice(0, 6) + '*******' + idNumber.slice(15)
    },
    loadMeetingPointOptions() {
      this.$http.request('meetingPointOptions').then(res => {
        this.meetingPointOptions = res.data || []
      })
    },
    openEditMeeting(order) {
      const mi = order.meeting_info || {}
      const existsInOptions = mi.id && this.meetingPointOptions.some(mp => mp.id === Number(mi.id))
      this.editMeeting.form.uuid = order.uuid
      this.editMeeting.form.meeting_point_id = existsInOptions ? Number(mi.id) : ''
      this.editMeeting.form.meeting_point = mi.name || order.meeting_point || ''
      this.editMeeting.form.meeting_time = mi.time || order.meeting_time || ''
      this.editMeeting.show = true
    },
    onEditMeetingPointChange(id) {
      const mp = this.meetingPointOptions.find(item => item.id === id)
      this.editMeeting.form.meeting_point = mp ? mp.name : ''
    },
    submitEditMeeting() {
      const f = this.editMeeting.form
      if (!f.meeting_point_id && !f.meeting_point && !f.meeting_time) {
        this.$message.warning('请选择集合地点或集合时间')
        return
      }
      this.editMeeting.loading = true
      this.$http.request('updateMeetingInfo', f).then(res => {
        this.editMeeting.loading = false
        if (res.status === 'success') {
          this.editMeeting.show = false
          this.$message.success('集合点已更新')
          this.loadList()
        }
      }).catch(() => { this.editMeeting.loading = false })
    },
  },
  created() {
    this.loadList(1)
    this.getProductList()
    this.getAppOptions()
    this.loadMeetingPointOptions()
  },
}
</script>

<style scoped>
.mp-detail {
  font-size: 12px;
  line-height: 1.6;
  color: #303133;
}
.mp-detail-row {
  margin-bottom: 4px;
  color: #606266;
}
.mp-detail-row strong {
  color: #303133;
}
.mp-detail-images {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  margin-top: 4px;
}
.mp-detail-thumb {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  overflow: hidden;
}

.order-card {
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  margin-top: 24px;
  overflow: hidden;
}

.order-header {
  background: #f7f8fa;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #eaeaea;
}

.order-meta-grid {
  display: flex;
  flex-wrap: wrap;
  flex: 1;
}

.meta-item {
  width: 33%;
  font-size: 12px;
  padding: 3px 0;
  color: #333;
}

.meta-item label {
  color: #999;
}

.order-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  min-width: 100px;
}

.progress-text {
  font-size: 12px;
  color: #409EFF;
  font-weight: bold;
}

.people-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.people-table th {
  background: #f0f2f5;
  padding: 8px 10px;
  border: 1px solid #eaeaea;
  text-align: left;
  font-weight: normal;
  color: #666;
}

.people-table td {
  padding: 8px 10px;
  border: 1px solid #eaeaea;
}

.ticketed-row {
  background: #f6ffed;
}

.no-data {
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  margin-top: 40px;
  color: #999;
}

.page-wrap {
  margin-top: 20px;
  text-align: center;
}

.ticket-dialog-info p {
  margin: 4px 0;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/ticket-processing.vue